import { atom } from "recoil";

export const actionProfitPricingTableRowsState = atom({
  key: "actionProfitPricingTableRowsState",
  default: [],
});
